const drupalBaseEndpoint =  `https://${process.env.REACT_APP_DRUPAL_API}`;
const drupalBaseJsonApi = 'jsonapi';
const drupalBaseRestApi = 'rest';

export { drupalBaseJsonApi, drupalBaseRestApi };

export default drupalBaseEndpoint;
